/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Prefix } from '../../models/prefix';

export interface ApiMasterPrefixGetActiveGet$Params {
}

export function apiMasterPrefixGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterPrefixGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Prefix>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterPrefixGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Prefix>>;
    })
  );
}

apiMasterPrefixGetActiveGet.PATH = '/api/Master/Prefix/GetActive';
